import React, { useContext, useEffect } from 'react';
import { Link } from 'gatsby';
import { InView } from 'react-intersection-observer';
import { GlobalState, ScrollPosition } from '../../store';
import WebsiteVideo from '../WebsiteVideo';
import WebsiteInfo from '../WebsiteInfo';
import { Wrapper, FrameWrapper, Frame, Title, Dots, Dot } from './style';

const Website = ({ isActive, isInactive, website }) => {
  const { theme } = useContext(GlobalState.State);
  const scrollPositionDispatch = useContext(ScrollPosition.Dispatch);
  const { scrollProgress } = useContext(ScrollPosition.State);

  const videoSrc = website.video ? website.video.file.url : website.videoLink;

  const handleInViewChange = inView => {
    if (inView) {
      scrollPositionDispatch({
        type: 'setHandleContent',
        value: scrollProgress ? website.year : '2019'
      })
    }
  }

  return (
    <InView threshold={1} onChange={handleInViewChange}>
      {({ ref }) => (
        <Wrapper id={website.id} isActive={isActive} isInactive={isInactive} ref={ref}>
          <FrameWrapper isActive={isActive} isInactive={isInactive}>
            <Frame backgroundColor={theme.backgroundColor}>
              <Title>
                {/* <Dots>
                  <Dot />
                  <Dot />
                  <Dot />
                </Dots> */}
                {website.title}
              </Title>
              <WebsiteVideo
                isActive={isActive}
                video={videoSrc}
                poster={website.poster}
              />
            </Frame>
            {isActive ? null : <Link to={`/${website.slug}`} />}
            <WebsiteInfo
              isActive={isActive}
              isInactive={isInactive}
              website={website}
            />
          </FrameWrapper>
        </Wrapper>
      )}
    </InView>
  );
};

export default Website;
